// extracted by mini-css-extract-plugin
export default {"title":"styles_title__2F-5W","p":"styles_p__-2KJ5"};